import { z } from "zod";

export const SocialAuthProvider = z.enum(["google", "apple", "wechat"]);
export type SocialAuthProvider = z.infer<typeof SocialAuthProvider>;

/** What the web and iOS apps read before signing in: the sign-in methods and the risk SDK keys. */
export const ClientConfig = z.strictObject({
  socialProviders: z.array(SocialAuthProvider),
  /** The key Castle's browser and iOS SDKs mint request tokens with; null skips Castle. */
  castlePublishableKey: z.string().nullable(),
  /** The reCAPTCHA Enterprise key the web app's bot check runs with; null when there's none. */
  recaptchaWebSiteKey: z.string().nullable(),
});
export type ClientConfig = z.infer<typeof ClientConfig>;

export const clientConfig = {
  path: "/api/config/client",
  response: ClientConfig,
} as const;
